import { defineComponent as _defineComponent } from 'vue'
import { useI18n } from '@/composables/i18n';
import { useSpinner } from '@/composables/misc';
import { localeService } from '@/library-services/locale.service';
import { downloadTermsAndConditionsPdf } from '@/utils/misc';
import { computed } from 'vue';


/** @deprecated THIS COMPONENT IS FROZEN
 * Menu in the page header to access information about the application.
 */
const __default__ = {};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'InformationMenu',
  setup(__props) {

const spinner = useSpinner();
const { t } = useI18n();

async function downloadTermsAndConditions() {
  spinner.showSpinner();
  await downloadTermsAndConditionsPdf().finally(() => spinner.removeSpinner());
}

const onlineHelpLink = computed(
  () =>
    `https://onlinehelp.bystronic.com/BySoft_Insight/${languageCode.value}/Content/Home.htm?apikey=148ad74c-384b-4471-8abb-87cba0b9f24e`,
);

const languageCode = computed(() => {
  switch (localeService.currentLocale) {
    case 'da':
    case 'de':
    case 'es':
    case 'fr':
    case 'it':
    case 'ko':
    case 'pl':
      return localeService.currentLocale;
    case 'zh':
      return 'zh-cn';
    default:
      return 'en-us';
  }
});

return { __sfc: true,spinner, t, downloadTermsAndConditions, onlineHelpLink, languageCode }
}

})